<template>
  <div
    class="app-main-inner alert-settings-form"
    style="display: flex;flex-direction: column;"
  >
    <div class="app-main-inner-row" style="margin-left: -32px !important;">
      <div style="display: flex;">
        <!--明细-->
        <el-card class="box-card content-wrapper">
          <div slot="header">
            <span style="font-size: 16px;">{{ $t('SystemMaintenance.AlertContentConfiguration') }}</span>
          </div>
          <el-form
            :disabled="readonly"
            label-width="100px"
            label-position="left"
          >
            <el-form-item :label="$t('CargoMsg.Cargo_WarningSwitch')">
              <el-radio-group v-model="form.open">
                <el-radio :label="1">{{ $t('CargoMsg.Cargo_StartAlert') }}</el-radio>
                <el-radio :label="0">{{ $t('CargoMsg.Cargo_CloseAlert') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WarningConditions')">
              <cargo-advance-select
                :default-value="form.warningDateField"
                :static-options="alertTypes"
                tag-value="code"
                filterable
                filter-type="global"
                :cache="false"
                style="width: 200px"
                @parentCallBack="p=>{form.warningDateField=p.value}"
              />
            </el-form-item>
            <el-form-item v-show="showNodeStatus" :label="$t('Sop.SelectTheNode')">
              <cargo-advance-select
                :default-value="form.triggerTrackingDetailUuid"
                :static-options="completeNodeStatus"
                :cache="false"
                filterable
                filter-type="global"
                tag-value="trackingDetailUuid"
                :custom-label="(item)=>`${item.codeCname}(${item.subCodeCname})`"
                style="width: 200px"
                @parentCallBack="p=>{form.triggerTrackingDetailUuid=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WarningContent')">
              <el-input v-model="form.content" style="width: 240px" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AutoIgnoreMode')">
              <el-radio-group v-model="form.ignoreType">
                <el-radio :label="1">{{ $t('CargoMsg.Cargo_EarlyTimedIgnore') }}</el-radio>
                <el-radio :label="0">{{ $t('CargoMsg.Cargo_TurnOffAutoIgnore') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_IgnoreTime')">
              <div style="display: flex">
                <el-input v-model="form.ignoreTime" :disabled="form.ignoreType === 0" oninput="value=value.replace(/[^\d]/g,'')" type="number" style="width: 120px !important;" />
                <span style="margin-left: 5px">{{ $t('CargoMsg.Cargo_AutomaticallyIgnoreAfterHours') }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ApplicationScope')">
              <el-radio-group v-model="ignoreMode" :disabled="!!form.triggerTrackingDetailUuid">
                <el-radio :label="true" style="margin-bottom: 5px">{{ $t('CargoMsg.Cargo_ApplyToAllTemplates') }}</el-radio>
                <el-radio :label="false">{{ $t('CargoMsg.Cargo_UseOnlyTheCurrentTemplate') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DocumentNotification')">
              <el-radio-group v-model="form.notifyJobType">
                <el-radio style="margin-bottom: 5px" :label="0">{{ $t('CargoMsg.Cargo_NoticeOfEachBill') }}</el-radio>
                <el-radio :label="1">{{ $t('CargoMsg.Cargo_NoNoticeOfTickets') }}</el-radio></el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_RemarksInfo')">
              <el-input v-model="form.remark" type="textarea" />
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card content-wrapper" style="margin-left: 5px; width: 430px !important;">
          <div slot="header">
            <span style="font-size: 16px;">{{ this.$t('SystemMaintenance.AlertTimeConfiguration') }}</span>
          </div>
          <el-form
            v-for="(item, index) in warningRuleItemList"
            :key="index"
            :disabled="readonly"
            label-width="80px"
            label-position="left"
            style="padding-left: 6px;"
          >
            <div v-if="item.ruleItem" style="margin-left: -25px;">
              <div style="margin-bottom: 5px">
                <span v-if="index + 1 === warningRuleItemList.length && warningRuleItemList.length !== 3" class="form-operator" @click="onAdd()"><i :class="readonly ? `readonly-operator` : `el-icon-circle-plus`" /></span>
                <span v-else class="form-operator" @click="onRemove(item, index)"><i :class="readonly ? `readonly-operator` : `el-icon-remove`" /></span>
                <el-select v-model="item.ruleItem" style="width: 100px; margin-right: 5px">
                  <el-option value="1" :label="$t('CargoMsg.Cargo_BringForward')" />
                  <el-option value="2" :label="$t('CargoMsg.Cargo_Postpone')" />
                </el-select>
                <el-input v-model="item.duration" type="number" oninput="value=value.replace(/[^\d]/g,'')" style="width: 50px; margin-right: 5px" />
                <span>{{ $t('Pricing.Hour') }}</span>
                <el-input-number v-model="item.minute" type="number" :min="0" :max="59" :step="1" :controls="false" style="width: 50px; margin-left: 5px; margin-right: 5px" />
                <span>{{ $t('CargoMsg.Cargo_EarlyWarningReminder') }}</span>
              </div>
            </div>
            <el-form-item :label="$t('CargoMsg.Cargo_WarningLevel')">
              <el-radio-group v-for="item2 in levels" :key="item2.code" v-model="item.level">
                <el-radio :label="item2.code" style="margin-right: 10px">{{ item2.chineseName }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <span class="title" style="margin-top: 20px;">{{ $t('CargoMsg.Cargo_SetAlertNotificationObject') }}</span>
            <div style="margin-left: 10px">
              <div>
                <el-checkbox v-model="item._ext.hasDesignatedPost" @change="item.notifierRoles=''">{{ $t('CargoMsg.Cargo_DesignatedPost') }}</el-checkbox>
              </div>
              <el-checkbox-group :value="toArray(item.notifierRoles)" :disabled="!item._ext.hasDesignatedPost" @input="val=>{item.notifierRoles=toTxt(val)}">
                <el-checkbox v-for="(item, index) in roles" :key="index" style="margin-top: 10px" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
              </el-checkbox-group>
              <div style="margin-top: 10px;">
                <el-checkbox v-model="item.notifySuperior" :disabled="!item.notifierRoles && !item.notifySuperior">{{ $t('SystemMaintenance.NotifySuperiors') }}</el-checkbox>
              </div>
              <div v-show="!isPlatform" style="margin-top: 10px">
                <el-checkbox v-model="item._ext.hasNotifierIds" @change="item.notifierIds=''">{{ $t('CargoMsg.Cargo_DesignatedPersonnel') }}</el-checkbox>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_User"
                  :fields="['chineseName']"
                  :disabled="!item._ext.hasNotifierIds"
                  :callback-params="{key:'userList'}"
                  callback-method-type="value"
                  tag-value="userId"
                  tag-name="chineseName"
                  :filter-tag-names="['chineseName']"
                  :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                  :default-multiple-value="toArray(item.notifierIds)"
                  multiple
                  filterable
                  style="width:205px;margin-top: 10px"
                  options-width="230px"
                  @parentCallBack="p=>{item.notifierIds=toTxt(p.value)}"
                />
              </div>
              <div style="margin-top: 10px">
                <el-checkbox :value="!!item.enableMail" @input="val=>{item.enableMail=val?1:0}">{{ $t('Viewer.email') }}</el-checkbox>
                <el-checkbox :value="!!item.enableWeChat" @input="val=>{item.enableWeChat=val?1:0}">{{ $t('CargoMsg.Cargo_Wechat') }}</el-checkbox><i class="el-icon-warning icon-tip" @click="dialogVisible = true" />
              </div>
              <el-form-item v-if="item.enableMail" :label="$t('SystemMaintenance.MailServer')">
                <el-select v-model="item.mailServerType" style="width: 200px;">
                  <el-option
                    v-for="(item, index) in mailServers"
                    :key="index"
                    :value="item.code"
                    :label="item.chineseName"
                  />
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </el-card>
      </div>
    </div>

    <!-- 微信预警操作提示 -->
    <el-dialog
      no="MattersNeedingAttention"
      :visible.sync="dialogVisible"
      :title="$t('Message.Tip')"
      class="sea-house-dialog"
      style="width: 2000px"
    >
      <div class="dialog-txt">
        <h6><i class="el-icon-warning icon-tip" />{{ $t('SeaExport.WechatPrompt') }}</h6>
        <img
          src="@/assets/WechatPrompt_1.png"
          style="width: 300px; height: 300px"
        >
        <img
          src="@/assets/WechatPrompt_2.png"
          style="width: 250px; height: 300px"
        >
        <img
          src="@/assets/WechatPrompt_3.png"
          style="width: 300px;position: absolute; left:65%; top: 50%; margin-left: -60px;margin-top: -20px;"
        >
      </div>
      <div slot="footer">
        <el-button plain @click="dialogVisible = false">{{ $t('common.btn.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { saveWarningRule } from '@/api/sysManage/baseConfig/warnRuleConfiguration'
import { getLoading } from '@/utils/utilBaseElement'
import * as commonUtil from '@/utils/commonUtil'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
export default {
  name: 'AlertSettingsForm',
  components: { CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    form: {
      type: Object,
      default: () => {}
    },
    sopTemplateCodeList: { // 模板节点code list
      type: Array,
      default: () => []
    },
    templateCompleteNodeStatus: { // 当前sop模板已完成的节点状态列表
      type: Array,
      default: () => []
    },
    opStatus: { type: String, default: '' }, // 操作状态：add|edit|read,
    defaultWarnName: { type: String, default: '' }, // 默认的预警名称,
    lob: { type: String, default: 'SE' }
  },
  data() {
    return {
      showNodeStatus: false,
      completeNodeStatus: [],
      alertTypes: [],
      trackingDetailForm: { innerConfig: {}},
      selectTypeNames: TYPE_NAMES,
      levels: Array.from(SystemConstants.LEVELS),
      mailServers: Array.from(SystemConstants.EMAIL_SERVERS_CONFIG),
      roles: CargoOfRoleType.WARNING_ROLE_TYPES,
      isZh: this.$store.getters.language === 'zh',
      ignoreMode: false, // 应用范围，true 应用到所有模板，false 仅当前模板使用
      fullscreenLoading: null,
      newForm: { warningDateField: 0, triggerTrackingDetailUuid: '', content: '', open: 0, ruleItem: '1', duration: 48, minute: 0, level: 1, ignoreType: 1, notifyJobType: 0, ignoreTime: 24, action: 0, warningRuleItemList: [] },
      warningRuleItemList: [],
      dialogVisible: false
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    isNew() {
      return this.opStatus === 'add'
    },
    isEdit() {
      return this.opStatus === 'edit'
    },
    readonly() {
      return this.opStatus === 'read'
    },
    isPlatform() {
      return this.$store.getters.tenantId === 1
    }
  },
  watch: {
    'form.ignoreType': function(val) {
      if (val === 0) {
        this.form.ignoreTime = ''
      } else {
        this.form.ignoreTime = 24
      }
    },
    'form.warningDateField': function(val) {
      const showNodeStatus = this.changeWarningDateField(val)
      if (!showNodeStatus) {
        this.form.triggerTrackingDetailUuid = ''
      }
      this.showNodeStatus = showNodeStatus
    },
    'form.triggerTrackingDetailUuid': function(val) {
      if (val) {
        this.ignoreMode = false
      }
    },
    ignoreMode(val) {
      this.form.syncTemplate = val
    }
  },
  methods: {
    async onShow() {
      await this.init()
      this.completeNodeStatus = this.templateCompleteNodeStatus
      this.warningRuleItemList = this.getFilterWarningRuleItemList()
      if ((!this.form.warningRuleItemList || this.form.warningRuleItemList.length === 0)) {
        if (!this.readonly) {
          this.onAdd()
        } else {
          this.onAddAtReadonly()
        }
      }
      if (!this.readonly && !this.form.uuid) {
        // 若没有预警信息，编辑预警时，初始化预警相关数据
        this.form.content = this.defaultWarnName
        commonUtil.objCopyNoExistsOrNull(this.newForm, this.form)
        // 初始化预警条件
        if (!this.form.warningDateField && this.alertTypes.length !== 0) {
          this.form.warningDateField = this.alertTypes[0].code
        }
      }
      // 预警条件为空的时候，warningDateField字段会有默认值0展示在选项框中
      if (this.alertTypes.length === 0) {
        this.form.warningDateField = ''
      }

      this.showNodeStatus = this.changeWarningDateField(this.form.warningDateField)
    },
    async init() {
      const sopConfig = await SopUtil.getInstance()
      const warnRules = sopConfig.warnDateEnum
      this.alertTypes = warnRules.filter(item => item.lob === this.lob && item.warnType === 1 && this.checkCodeEnum(item))
    },
    commitHandler() {
      this.fullscreenLoading = getLoading()
      this.form.syncTemplate = this.ignoreMode
      saveWarningRule(this.form).then((res) => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        commonUtil.objCopy(this.form, this.source)
        this.$emit('reload')
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    onAdd() {
      if (this.warningRuleItemList.length >= 3) {
        return
      }
      const len = 1 + (this.warningRuleItemList.length === 0 ? 1 : this.warningRuleItemList.length * 2)
      const item = {
        ruleItem: '1',
        duration: len * 24,
        minute: 0,
        action: 0,
        warningRuleUuid: this.form.uuid,
        tenantId: this.$store.getters.tenantId,
        level: 1,
        notifierRoles: '1,2',
        notifierIds: '',
        enableMail: 1,
        enableWeChat: 0,
        mailServerType: 0,
        notifySuperior: false,
        _ext: {
          hasDesignatedPost: true,
          hasNotifierIds: false
        }
      }
      this.form.warningRuleItemList.push(item)
      this.warningRuleItemList.push(item)
    },
    onAddAtReadonly() {
      if (this.warningRuleItemList.length >= 3) {
        return
      }
      const item = {
        ruleItem: '',
        duration: 0,
        minute: 0,
        action: 0,
        warningRuleUuid: this.form.uuid,
        tenantId: this.$store.getters.tenantId,
        level: '',
        notifierRoles: '',
        notifierIds: '',
        enableMail: 0,
        enableWeChat: 0,
        mailServerType: 0,
        _ext: {
          hasDesignatedPost: false,
          hasNotifierIds: false
        }
      }
      this.warningRuleItemList.push(item)
    },
    onRemove(item, index) {
      if (item.uuid) {
        item.action = 2
        this.warningRuleItemList.splice(index, 1)
      } else {
        this.warningRuleItemList.splice(index, 1)
        const index2 = this.form.warningRuleItemList.findIndex(p => p === item)
        if (index2 > -1) {
          this.form.warningRuleItemList.splice(index2, 1)
        }
      }
    },
    close() {
      this.$emit('close')
    },
    /**
     * 校验预警条件是否符合
     * @param item
     * @returns {boolean}
     */
    checkCodeEnum(item) {
      return item.table === 'OMS_TRACKING_INFO' && item.field ? item.field === 'TRIGGER_TRACKING_DETAIL_UUID' || this.sopTemplateCodeList.findIndex(data => item.field === data) > -1 : true
    },
    changeWarningDateField(val) {
      if (!val) {
        return false
      }
      const alertType = this.alertTypes.filter(item => item.code === val)
      if (!alertType || alertType.length === 0) {
        return false
      }
      return alertType[0].field === 'TRIGGER_TRACKING_DETAIL_UUID'
    },
    toArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    getFilterWarningRuleItemList() {
      const result = []
      if (this.form.warningRuleItemList) {
        for (let i = 0; i < this.form.warningRuleItemList.length; ++i) {
          let item = this.form.warningRuleItemList[i]
          if (item.action !== 2) {
            if (item._ext) {
              item._ext.hasDesignatedPost = !!item.notifierRoles
              item._ext.hasNotifierIds = !!item.notifierIds
            } else {
              item = {
                ...item,
                _ext: {
                  hasDesignatedPost: !!item.notifierRoles,
                  hasNotifierIds: !!item.notifierIds
                }
              }
              this.form.warningRuleItemList[i] = item
            }
            result.push(item)
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
  .alert-settings-form {
    .box-card{
      /deep/.el-card__header{
        padding: 10px 20px !important;
      }
    }
    .primary-text {
      color: $--color-primary;
    }
    .content-wrapper {
      display: flex;
      flex-direction: column;
      width: 400px !important;
      .custom {
        .el-form-item__content {
          width: auto;
        }
      }

      .el-radio__label{
        font-size: 12px;
      }
      .el-form-item__content {
        width: 260px !important;
        textarea {
          width: 240px;
          height: 56px;
        }
        .cargo-advance-select-wrapper{
          width: 240px !important;
        }
      }

      .form-operator {
        margin-left: 5px;
        margin-right: 5px;
        cursor: pointer;
        font-size: 18px;
        .readonly-operator {
          margin-left: 16px;
        }
        .el-icon-circle-plus {
          font-size: medium;
          color: $--color-success;
        }

        .el-icon-remove {
          font-size: medium;
          color: $--color-danger;
        }
      }
    }
    .icon-tip{
      vertical-align: middle;
      margin-bottom: 4px;
      margin-left: 2px;
      color: orange;
      font-size: 18px;
      cursor: pointer;
    }
  }
.sea-house-dialog{
  .dialog-txt{
    padding: 0 20px 10px 20px;
    h6{
      line-height: 20px;
      margin: 20px 0 10px 0;
      color: #333;
      font-size: 16px;
      font-weight: normal;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      i{
        margin-right: 8px;
        color: orange;
        font-size: 20px;
      }
    }
  }
}
</style>
